import { Injectable } from '@angular/core';
import {GetHomeContent_homeContent} from "../queries/__generated__/GetHomeContent";
import {HomeContent} from "../interfaces/home-content";
import {ImageService} from "../atoms/image/image.service";
import {StoryService} from "./story.service";

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(
    private imageService: ImageService,
    private storyService: StoryService
  ) { }

  mapRawHomeContent(homeContent: GetHomeContent_homeContent): HomeContent {
    let parsedHomeContent: HomeContent = {
      featuredCompanies: [],
      featuredStories: [],
      helpfulLinks: []
    }

    if(homeContent.featuredCompanies?.length) {
      homeContent.featuredCompanies.forEach(rawFeaturedCompany => {
        parsedHomeContent.featuredCompanies.push(this.imageService.mapRawImageData(rawFeaturedCompany.companyProfilePicture));
      });
    }

    if(homeContent.featuredStories?.length) {
      homeContent.featuredStories.forEach(rawFeaturedStory => {
        parsedHomeContent.featuredStories.push(this.storyService.mapRawStoryData(rawFeaturedStory));
      });
    }

    if(homeContent.helpfulLinks?.length) {
      parsedHomeContent.helpfulLinks = homeContent.helpfulLinks.map((link) => {
        return {
          target: link.linkTargetType === "BLANK" ? "_blank" : "",
          title: link.heading,
          link: link.link,
          type: link.typeName,
          position: link.position ?? 9999
        }
      });
    }

    return parsedHomeContent;
  }
}
